// Marketing copy for C2C plans, keyed by plan_code. Load-bearing fields — price,
// which plans exist, gating flags — come from GET /api/payments/plans. This file
// holds ONLY presentation. No popularity badges, no outcome/ROI claims.
export const C2C_PLAN_PRESENTATION = {
  free: {
    tagline: 'Try it out',
    description: 'Get a feel for AI interview practice — no card needed.',
    accent: '#6b7280',
    cta: 'Start for free',
    features: [
      '3 Quick interviews / month',
      'AI picks your questions',
      'Friend coach mode',
      'Instant feedback after each answer',
    ],
  },
  sprint_monthly: {
    tagline: 'Interview coming up?',
    description: 'Focused practice to walk in prepared.',
    accent: '#f97316',
    cta: 'Choose Sprint',
    features: [
      '20 interviews / month',
      'Quick + Standard formats',
      'Friend, Guide & Challenger coaches',
      'BARS summary scoring',
      'All question topics',
      'Progress tracking',
    ],
  },
  pro_monthly: {
    tagline: 'Serious job hunt',
    description: 'Unlimited realistic mocks with expert feedback.',
    accent: '#1d4ed8',
    cta: 'Choose Pro',
    features: [
      'Unlimited interviews, all formats',
      'Full 20-question mock interviews',
      'All coaches incl. Drill Sergeant',
      'Expert BARS scoring + Action Plan',
      'Resume-tailored questions',
      'Unlimited history + growth map',
    ],
  },
  tester_full_eur_monthly: {
    tagline: 'Real-payment QA',
    description: 'Tester-only full access.',
    accent: '#0f766e',
    cta: 'Pay €1 (Test)',
    features: ['Full access for payment QA'],
  },
};
